<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
    <g fill="none" fill-rule="evenodd">
        <circle cx="11.163" cy="11.163" r="11.163" fill="#C50000"/>
        <g stroke="#FFF" stroke-linecap="square" stroke-width="1.5">
            <path d="M14.65 8.117L8.117 14.65M14.65 14.65L8.117 8.117"/>
        </g>
    </g>
</svg>
